import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAxiosInterceptor } from './AxiosInterceptorProvider';

const AuthContext = React.createContext({
  isTokenSet: false,
  isAuthenticated: false,
  isLoading: true,
});

export const CommonAuthProvider = ({ children }) => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const { isTokenSet } = useAxiosInterceptor();
  const value = { isTokenSet, isLoading, isAuthenticated, getAccessTokenSilently };
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a CommonAuthProvider');
  }
  return context;
};